import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { StampGrid } from "../components/StampGrid";
import { SaveToPhone } from "../components/SaveToPhone";
import { LOYALTY_GOAL } from "../lib/format";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function LoyaltyCardPage() {
  const { token } = useParams();
  const [card, setCard] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${BASE}/api/loyalty/card/${token}`).then((r) => setCard(r.data)).catch(() => setError("Tessera non trovata"));
  }, [token]);

  if (error) return <div data-testid="loyalty-page-error" className="min-h-screen flex items-center justify-center text-[#6F6466]">{error}</div>;
  if (!card) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#0B1F3A]" /></div>;

  const left = LOYALTY_GOAL - card.stamps;
  return (
    <main data-testid="loyalty-page" className="min-h-screen flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="rounded-3xl bg-[#0B1F3A] text-[#F7F2EC] p-7 noise-overlay relative overflow-hidden shadow-[0_30px_80px_rgba(11,31,58,0.35)]">
          <div className="relative z-10 text-center">
            <p className="font-display font-black text-5xl leading-none">BANY</p>
            <p className="font-mono-alt text-[10px] tracking-[0.45em] uppercase opacity-70 mt-1 mb-6">Tessera fedeltà</p>
            <img data-testid="loyalty-page-qr" src={`${BASE}/api/loyalty/qr/${token}.png`} alt="QR tessera" className="mx-auto w-52 h-52 rounded-2xl bg-white p-2" />
            <p data-testid="loyalty-page-code" className="font-mono-alt text-lg tracking-[0.25em] mt-4">{card.code}</p>
            {card.name && <p className="text-sm opacity-70 mt-1">{card.name}</p>}
          </div>
        </div>
        <div className="mt-8"><StampGrid stamps={card.stamps} prefix="loyalty-page-stamp" /></div>
        <p data-testid="loyalty-page-status" className="mt-5 text-center text-sm text-[#1A1416]">
          {card.reward_available ? <strong className="text-[#C2410C]">Hai 10 timbri: il prossimo taglio ha il 50% di sconto!</strong> : <>Timbri <strong>{card.stamps}/{LOYALTY_GOAL}</strong> · ancora {left} {left === 1 ? "taglio" : "tagli"} per lo sconto del 50%</>}
        </p>
        <p className="mt-2 text-center text-xs text-[#6F6466]">Mostra questo QR al barbiere a ogni taglio.</p>
        <SaveToPhone token={token} />
      </div>
    </main>
  );
}
